export function capitalize(value) {
    return value.length === 0 ? value : value.charAt(0).toUpperCase() + value.slice(1);
}
//# sourceMappingURL=capitalize.js.map